import React from 'react';
import { map } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { dispositionNotesWidget as DispositionNotesWidget } from 'ui/views/widgets/dispositionNotesWidget';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { offCallDispositionNotes as OffCallDispositionNotes } from 'ui/views/widgets/offCallDispositionNotes';
 *
 * // render
 * <OffCallDispositionNotes propName='propValue'/>
 */
export const offCallDispositionNotesSuccess = ( props ) => {
    return (
        <div className='ui-off-call-disposition-notes'>
            <DispositionNotesWidget { ...props } />
        </div>
    );
};

// set display name
offCallDispositionNotesSuccess.displayName = 'offCallDispositionNotesSuccess';

// set default props
offCallDispositionNotesSuccess.defaultProps = {};

// prop types
offCallDispositionNotesSuccess.propTypes = {};

/*******************************/

// preloader view

export const offCallDispositionNotesPreloader = () => {
	return (
        <div className='ui-off-call-disposition-notes-preloader'>
            <div className='ui-off-call-disposition-notes-preloader__actions'>
                <div className='ui-off-call-disposition-notes-preloader__actions__button' />
            </div>

            <div className='ui-off-call-disposition-notes-preloader__items'>
                {
                    map( [ 1, 2 ], item => {
                        return (
                            <div key={ item } className='ui-off-call-disposition-notes-preloader__items__item'>
								<div className='ui-off-call-disposition-notes-preloader__items__item__header'>
									<div className='ui-off-call-disposition-notes-preloader__items__item__header__text' />
									<div className='ui-off-call-disposition-notes-preloader__items__item__header__actions' />
								</div>
								<div className='ui-off-call-disposition-notes-preloader__items__item__description'></div>
                            </div>
                        );
                    } )
                }
            </div>
        </div>
    );
 };

// set display name
offCallDispositionNotesPreloader.displayName = 'offCallDispositionNotesPreloader';

// set default props
offCallDispositionNotesPreloader.defaultProps = {};

// prop types
offCallDispositionNotesPreloader.propTypes = {};

/* ******************************************************* */

/**
 * @type { object }
 * @desc A React presentation/dumb view component.
 * @example
 * import { callDispositionNotes as CallDispositionNotes } from 'ui/views/widgets/callDispositionNotes';
 *
 * // render
 * <CallDispositionNotes propName='propValue'/>
 */

export const offCallDispositionNotes = withNetworkState(
	offCallDispositionNotesPreloader,
	offCallDispositionNotesSuccess
 );
